module.exports = __webpack_public_path__ + "img/dea-formazione-ico-benessere-a-scuola.f9a068db.svg";